export function SET_SHOW_MOBILE_LOYALTY_PROGRAM(state, show) {
  state.showMobileLoyaltyProgram = !!show
}
